import * as stylex from "@stylexjs/stylex";
import { motion, useCycle } from "framer-motion";
import * as M from "../../materials";
import { colors, layoutAreas } from "../../materials/consts.stylex";
import { themeVars } from "../../materials/theme.stylex";
import { QualityFrameworkTable } from "./quality-framework-table";
const buttonOpen = new URL("../../icons/svg/ic_expand_24dp.svg", import.meta.url).href;
const stylexStyles = {
    root: {
        keoZOQ: "x1x8no7b",
        k9WMMc: "x2b8uid",
        kLKAdn: "x1miatn0",
        $$css: true
    },
    rootOpen: {
        kWkggS: "xjbqb8w",
        $$css: true
    },
    rootClosed: {
        kWkggS: "xbxt5nw",
        $$css: true
    }
};
export const QualityFramework = ({ highlighted, description })=>{
    const [isOpen, toggleOpen] = useCycle(true, false);
    return <M.Grid layout={"article"} sx={[
        stylexStyles.root,
        isOpen ? stylexStyles.rootOpen : stylexStyles.rootClosed
    ]}>
      <motion.button {...{
        0: {
            className: "x16rqkct x2b8uid xmkeg23 x1y0btm7 x9r1u3d x1bpp3o7 xxk0z11 xvy4d1p x78zum5 x1k74hu9 x1717udv x1a2a7pz x1277o0a x784prv x9v5kkp xjik3cz x7s97pk"
        },
        1: {
            className: "x16rqkct x1717udv x1a2a7pz x1277o0a x784prv x9v5kkp xjik3cz x7s97pk x6e1os3 xmkeg23 x1y0btm7 x1wzfk3z x2b8uid x1bpp3o7 x1afcbsf xxk0z11 xvy4d1p x78zum5"
        }
    }[!!isOpen << 0]} animate={isOpen ? {
        scale: 1.0,
        rotate: 0
    } : {
        scale: 1.5,
        rotate: 45
    }} whileHover={{
        scale: 1.2
    }} onClick={()=>{
        toggleOpen();
    }} aria-expanded={isOpen}>
        <img src={buttonOpen} alt="" className="x20nx6h"/>
      </motion.button>
      {isOpen ? <p className="x12klvby x8v10ko x78zum5 x7v7x1q x8x9d4c xack27t">{description}</p> : <motion.div style={{
        height: 0
    }} animate={{
        height: "auto"
    }} transition={{
        duration: 0.3
    }} className="xvaai34 xbxt5nw xdj266r">
          <motion.div initial={{
        opacity: 0
    }} animate={{
        opacity: 1
    }} transition={{
        delay: 0.3,
        duration: 0.4,
        ease: "easeIn"
    }}>
            <QualityFrameworkTable highlighted={highlighted}/>
          </motion.div>
        </motion.div>}
    </M.Grid>;
};
